import type { FC } from 'react';

import { useTimeLeft } from '@wwe-portal/ui/lib/hooks';

import { Countdown } from './countdown';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

export interface TimeCountDownProps {
  endDate: Date | number | string;
  className?: string;
  endTimeString?: string;
}
export const OfferTimeCountDown: FC<TimeCountDownProps> = ({
  endDate,
  className,
  endTimeString,
}) => {
  const { isHydrated } = useResponsive();
  const { getTimeText } = useTimeLeft(endDate);
  const getText = () => {
    const timeText = getTimeText(' ');
    if (timeText === '' && endTimeString) return endTimeString;

    return timeText;
  };

  if (!isHydrated) return null;
  return <Countdown className={className}>{getText()}</Countdown>;
};
